export default function getSidetripsForPlaceFactory(ajax) {
  return async function getSidetripsForPlace({ placeId, limit, page }) {
    return await ajax({
      resource: `trips/sidetrips?place=${placeId}&per_page=${limit}&page=${page}`,
    });
  };
}



// WEBPACK FOOTER //
// ./src/services/getSidetripsForPlace.js